/**
 * PD-6630: On the homepage, show most-popular restaurant carousels for the country's top cities (a saved city, including a suburb resolved to its parent city, instead gets book tonight, most popular, browse-by-cuisine, and new venues), a scrollable list of that country's locations above how it works, the blue find-a-table button, and a how-it-works heading. The steps use the treatment titles and messages rather than the control copy.
 *
 * @see https://firsttable.atlassian.net/browse/PD-6630
 * @see https://www.figma.com/design/11lqNMVfRoQzCPx8oj12ab/E-%7C-A-B-tests?node-id=4015-67160
 * @see https://app.growthbook.io/features/pd-6630-re-test-homepage-experiment-for-web
 */
export const PD6630_HOMEPAGE_RESTAURANTS_FLAG = 'pd-6630-re-test-homepage-experiment-for-web';
